// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"b75b50e9","63":"9ff8af12","151":"7b0994d8","348":"201d66e2","448":"60043203","453":"7b13441d","472":"dbe871c1","484":"bb872c5b","544":"87cfd62f","702":"d0d70400","772":"9ae5d005","858":"785a9036"}[chunkId] + ".chunk.js";
};